import React from 'react';
import './InfoBox.css';

Date.prototype.hhmmddmm = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  var hour = this.getHours();
  var min = this.getMinutes();
  return (hour > 9 ? '' : '0') + hour + ':' + (min > 9 ? '' : '0') + min + ' (' + (dd >9 ? '' : '0') + dd + '/' + (mm >9 ? '' : '0') + mm + ')';
}

export default function Explorer(props) {

	const movementDescription = (movement) => {
		if (movement === undefined)
			return 'Actividad desconocida';
		if (movement.type === 'VISIT') {
			if (movement.placeName !== undefined)
				return 'En ' + movement.placeName + ' desde las ' + new Date(movement.startTime).hhmmddmm();
			else
				return 'En un lugar nuevo desde las ' + new Date(movement.startTime).hhmmddmm();
		} else if (movement.type == 'COMMUTE') {
			return 'Viajando desde las ' + new Date(movement.startTime).hhmmddmm();
		}
	}
	
	const batteryDescription = (batteryStatus) => {
		if (batteryStatus === undefined)
			return (<p>'Se desconoce el estado de la bateria'</p>);
		return 'Bateria: ' + batteryStatus.batteryLevel + '%' + (batteryStatus.charging ? ' (cargando)' : '');
	}
	
	const ringModeDescription = (ringMode) => {
		if (ringMode === undefined)
			return 'Se desconoce el perfil de sonido';
		
		if (ringMode.ringMode === 'SILENT') {
			return 'Perfil de sonido: Silencio';
		} else if (ringMode.ringMode === 'VIBRATE') {
			return 'Perfil de sonido: Vibración';
		} else if (ringMode.ringMode === 'SOUND') {
			return 'Perfil de sonido: ' + ringMode.level + '%';
		}
		
		return 'Se desconoce el perfil de sonido';
	}
	
	const lastUpdateDescriptio = (userState) => {
		var diff = (new Date().getTime() - userState.reportTime);
			var minutes = Math.floor((diff / 1000) / 60);
		if (minutes < 60)
			return "Actualizado hace " + minutes + " minutos"
		else {
				var horas = Math.floor(minutes / 60);
			return "Actualizado hace " + horas +  " horas";
		}
	}
	
	const lastUse = (userState) => {
		if (userState.phoneUsage.lastScreenOff !== undefined) {
			var diff = (new Date().getTime() - userState.phoneUsage.lastScreenOff);
			var minutes = Math.floor((diff / 1000) / 60);
			if (minutes < 60)
				return "Ultimo uso del celular hace " + minutes + " minutos"
			else {
				var horas = Math.floor(minutes / 60);
				return "Ultimo uso del celular hace " + horas +  " horas";
			}
		}
	}
	
	return (
		<div className="infoBox" style={{'background':'white'}}>
			<h1>{props.userState.userName}</h1>
			<h2>{lastUpdateDescriptio(props.userState)}</h2>
			<hr/>
			<p>{movementDescription(props.userState.currentMovement)}</p>
			<p>{batteryDescription(props.userState.batteryStatus)}</p>
			<p>{ringModeDescription(props.userState.ringMode)}</p>
			<p>{lastUse(props.userState)}</p>
		</div>
	);
}

